export default __webpack_public_path__ + "static/media/Americo Dark.630f2595.svg";